import {
  CustomerMT,
  CustomerPermissionEnum,
  CustomerPermissionOnly,
  CustomerRoleEnum,
  CustomerRoleOnly,
} from '@/api/apis/customer';
import { sortAlphabetically } from '@/utils/helpers';

export const getContactList = (list?: CustomerMT[]) => {
  if (!list) return [];

  const mappedList = list.map((c) => ({
    value: c.id,
    name: `${c.lastName}, ${c.firstName}`,
  }));

  return sortAlphabetically(mappedList, 'name');
};

export const getRolesAndPermissions = (txCenterId?: string, customer?: CustomerMT) => {
  const txCenterRelation = customer?.customerInTxCenters?.find((c) => c.txCenterId === txCenterId);
  const mixedRoles = txCenterRelation?.roles ?? [];

  const roles = mixedRoles.filter((r) =>
    Object.values(CustomerRoleEnum).includes(r as CustomerRoleEnum),
  ) as CustomerRoleOnly[];

  const permissions = mixedRoles.filter((r) =>
    Object.values(CustomerPermissionEnum).includes(r as CustomerPermissionEnum),
  ) as CustomerPermissionOnly[];

  const currentRoles = txCenterRelation?.roles || [];

  return { roles, permissions, currentRoles };
};
